export function normalizeFormData(formData) {
  if (!formData || typeof formData !== 'object' || Array.isArray(formData)) {
    return formData;
  }

  return Object.fromEntries(
    Object.entries(formData).map(([key, value]) => {
      switch (key) {
        case 'versicherungssumme':
          return [key, normalizeVersicherungssumme(value)];
        default:
          return [key, value];
      }
    }),
  );
}

function normalizeVersicherungssumme(value) {
  const normalizedValue = value === '' || value == null ? null : Number(value);
  return isNaN(normalizedValue) ? null : normalizedValue;
}
